import { Navigate } from 'react-router-dom'

// No separate register screen — Supabase creates accounts automatically on first login
export default function Register() {
  return <Navigate to="/login" replace />
}
